import { parse } from '@nostr/tools/nip27'
import { neventEncode, naddrEncode, nprofileEncode } from '@nostr/tools/nip19'
import { ReactElement, useMemo } from 'react'
import { EmbeddedHashtag, EmbeddedMention, EmbeddedWebsocketUrl } from './Embedded'
import ExternalLink from './ExternalLink'

export default function ProfileAbout({ about, className }: { about?: string; className?: string }) {
  const aboutNodes = useMemo(() => {
    if (!about) return null

    const nodes: ReactElement[] = []
    for (const block of parse(about)) {
      switch (block.type) {
        case 'text': {
          nodes.push(<span key={nodes.length}>{block.text}</span>)
          break
        }
        case 'emoji': {
          nodes.push(<span key={nodes.length}>:{block.shortcode}:</span>)
          break
        }
        case 'url':
        case 'image':
        case 'video':
        case 'audio': {
          nodes.push(<ExternalLink key={nodes.length} url={block.url} />)
          break
        }
        case 'relay': {
          nodes.push(<EmbeddedWebsocketUrl key={nodes.length} url={block.url} />)
          break
        }
        case 'reference': {
          if ('id' in block.pointer) {
            nodes.push(<ExternalLink key={nodes.length} url={neventEncode(block.pointer)} />)
          } else if ('identifier' in block.pointer) {
            nodes.push(<ExternalLink key={nodes.length} url={naddrEncode(block.pointer)} />)
          } else {
            nodes.push(<EmbeddedMention key={nodes.length} user={nprofileEncode(block.pointer)} />)
          }
          nodes.push(<span key={nodes.length}> </span>)
          break
        }
        case 'hashtag': {
          nodes.push(<EmbeddedHashtag key={nodes.length} hashtag={block.value} />)
          nodes.push(<span key={nodes.length}> </span>)
          break
        }
      }
    }

    return nodes
  }, [about])

  return <div className={className}>{aboutNodes}</div>
}
